import React, { useCallback, useContext, useEffect, useState } from "react";
import InterfaceContext from "../Context";
import { languageContent, safeParse } from "../Util";
import { QuestionProps } from "./Props";
import { useModularMarkdown } from "../Hooks/ModularMarkdown";
import { ApplicationStateContext } from "../Contexts/ApplicationStateContext";
import { MonthDayYearInput } from "@aidkitorg/component-library";

export function DateQuestion(props: QuestionProps) {
  const context = useContext(InterfaceContext);
  const metadata = safeParse(props.Metadata as string);
  const monthAndYearOnly = !!metadata.monthAndYearOnly;

  const targetField = props["Target Field"]!;
  const { applicationStateChanged } = useContext(ApplicationStateContext);

  const externalValue = props.info[targetField] || "";
  const [value, setValue] = useState(externalValue);
  const isValid = !!value;

  useEffect(() => {
    setValue(externalValue);
  }, [externalValue]);

  useEffect(() => {
    applicationStateChanged({
      type: "change",
      questionId: props.Question,
      update: {
        validity: { state: isValid ? "valid" : "invalid" },
      },
    });
  }, [isValid]);

  const onChange = useCallback(
    (next: string) => {
      setValue(next);
      props.setInfoKey(targetField, next, !!next, false);
    },
    [targetField, props.setInfoKey],
  );

  const content = useModularMarkdown({
    content: props[languageContent(context.lang)] || "",
    info: props.info,
    replacer: (str) => str.replace(" **\n", "**\n").replace("^** ", "**"),
  });

  return (
    <MonthDayYearInput
      label={content}
      value={value}
      onChange={onChange}
      monthAndYearOnly={monthAndYearOnly}
    />
  );
}
